import { CodeHighlight } from '@mantine/code-highlight';
import { Button, Tabs } from '@mantine/core';
import { IconBrandGithub, IconCloudComputing } from '@tabler/icons-react';
import Link from 'next/link';
import GithubCIInstruction from './GithubCIInstruction';

export default function CIOptions({ testSuiteId }: { testSuiteId?: string }) {
  const apiCurl = [
    `export TEST_SUITE_ID=${testSuiteId}`,
    `export STABLY_API_KEY=your-api-key # Keep this secret safe`,
    ``,
    `curl -X 'POST' \\`,
    `  "https://api.stably.ai/v1/testSuite/$TEST_SUITE_ID/run" \\`,
    `  -H "accept: application/json" \\`,
    `  -H "Authorization: Bearer $STABLY_API_KEY"`,
  ].join('\n');

  return (
    <Tabs defaultValue="github">
      <Tabs.List>
        <Tabs.Tab
          value="github"
          leftSection={<IconBrandGithub />}
        >
          GitHub
        </Tabs.Tab>
        <Tabs.Tab
          value="other"
          leftSection={<IconCloudComputing />}
        >
          Others
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel
        value="github"
        className="p-4"
      >
        <GithubCIInstruction testSuiteId={testSuiteId} />
      </Tabs.Panel>

      <Tabs.Panel
        value="other"
        className="space-y-6 p-4"
      >
        <div>You can trigger test runs directly through our API.</div>
        <div className="text-sm font-light">
          This will work for any CI/CD platform, including Jenkins, GitLab CI, CircleCI, Vercel CI, and more.
        </div>

        <div>
          <div className="mb-2 text-sm text-gray-600 dark:text-gray-400">Example API Request:</div>
          <CodeHighlight
            language="bash"
            code={apiCurl}
          />
        </div>

        <div className="space-y-3 text-sm">
          <Button
            variant="light"
            color="outline"
            leftSection={<IconCloudComputing size={16} />}
            component="a"
            href="https://docs.stably.ai/api-reference/introduction"
            target="_blank"
          >
            View Full API Docs
          </Button>

          <div className="text-gray-600 dark:text-gray-400">
            Have questions about integrating Stably with your CI/CD?{' '}
            <Link
              href="mailto:neil@stably.ai?subject=CI/CD Integration Questions"
              className="font-medium text-gray-700 hover:underline dark:text-gray-300"
            >
              Contact our support team
            </Link>
          </div>
        </div>
      </Tabs.Panel>
    </Tabs>
  );
}
